import { Button, Grid, SvgIcon, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../theme';
import { UserContext } from '../../../components/shared/useUser';

type BulkUserManagementBoxProps = {
  onDownloadTemplate: () => void;
  onUploadTemplate: (event: React.ChangeEvent<HTMLInputElement>) => void;
  downloadTemplateLoading?: boolean;
};

const BulkUserManagementBox = ({ onDownloadTemplate, onUploadTemplate, downloadTemplateLoading }: BulkUserManagementBoxProps) => {
  const { t } = useTranslation('manageUsers');
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { selectedFranchise } = useContext(UserContext);

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDownloadClick = () => {
    if (!downloadTemplateLoading) {
      onDownloadTemplate();
    }
  };

  return (
    <Grid item
      container
      mt={5}
      xs={12}
      sx={{
        padding: '20px 20px 20px 20px',
        border: '1px solid',
        borderColor: theme.palette.custom.gray[300],
      }}>
      <Grid item
        xs={12}
        style={{ marginBottom: 30 }}>
        <Typography variant="textSM"
          fontWeight={600}>
          {t('managingUsersFor', { franchise: selectedFranchise?.franchiseName || t('noFranchise') })}
        </Typography>
      </Grid>
      <Grid
        item
        style={{ marginRight: 16 }}
      >
        <Button
          variant="primary"
          startIcon={<SvgIcon><DownloadIcon /></SvgIcon>}
          onClick={handleDownloadClick}
          size="lg"
        >
          {t('downloadBulkTemplate')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="secondary"
          startIcon={<SvgIcon><UploadIcon /></SvgIcon>}
          onClick={handleUploadClick}
          size="lg"
        >
          {t('uploadBulkTemplate')}
        </Button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept=".xlsx,.xls"
          onChange={onUploadTemplate}
        />
      </Grid>
    </Grid>
  );
};

export default BulkUserManagementBox;
